export default "__VITE_ASSET__T19VPAXO__"